var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/* eslint-disable no-underscore-dangle */
import { Children, isValidElement } from 'react';
var ColumnManager = /** @class */ (function () {
    function ColumnManager(columns, elements) {
        this._cached = {};
        this.columns = columns || this.normalize(elements);
    }
    ColumnManager.prototype.isAnyColumnsFixed = function () {
        var _this = this;
        return this._cache('isAnyColumnsFixed', function () { return _this.columns.some(function (column) { return !!column.fixed; }); });
    };
    ColumnManager.prototype.isAnyColumnsLeftFixed = function () {
        var _this = this;
        return this._cache('isAnyColumnsLeftFixed', function () {
            return _this.columns.some(function (column) { return column.fixed === 'left' || column.fixed === true; });
        });
    };
    ColumnManager.prototype.isAnyColumnsRightFixed = function () {
        var _this = this;
        return this._cache('isAnyColumnsRightFixed', function () {
            return _this.columns.some(function (column) { return column.fixed === 'right'; });
        });
    };
    ColumnManager.prototype.leftColumns = function () {
        var _this = this;
        return this._cache('leftColumns', function () {
            return _this.groupedColumns().filter(function (column) { return column.fixed === 'left' || column.fixed === true; });
        });
    };
    ColumnManager.prototype.rightColumns = function () {
        var _this = this;
        return this._cache('rightColumns', function () {
            return _this.groupedColumns().filter(function (column) { return column.fixed === 'right'; });
        });
    };
    ColumnManager.prototype.leafColumns = function () {
        var _this = this;
        return this._cache('leafColumns', function () { return _this._leafColumns(_this.columns); });
    };
    ColumnManager.prototype.leftLeafColumns = function () {
        var _this = this;
        return this._cache('leftLeafColumns', function () { return _this._leafColumns(_this.leftColumns()); });
    };
    ColumnManager.prototype.rightLeafColumns = function () {
        var _this = this;
        return this._cache('rightLeafColumns', function () { return _this._leafColumns(_this.rightColumns()); });
    };
    // add appropriate rowspan and colspan to column
    ColumnManager.prototype.groupedColumns = function () {
        var _this = this;
        return this._cache('groupedColumns', function () {
            var _groupColumns = function (columns, currentRow, parentColumn, rows) {
                if (currentRow === void 0) { currentRow = 0; }
                if (parentColumn === void 0) { parentColumn = {}; }
                if (rows === void 0) { rows = []; }
                /* eslint-disable no-param-reassign */
                // track how many rows we got
                rows[currentRow] = rows[currentRow] || [];
                var grouped = [];
                var setRowSpan = function (column) {
                    var rowSpan = rows.length - currentRow;
                    if (column &&
                        !column.children && // parent columns are supposed to be one row
                        rowSpan > 1 &&
                        (!column.rowSpan || column.rowSpan < rowSpan)) {
                        column.rowSpan = rowSpan;
                    }
                };
                columns.forEach(function (column, index) {
                    var newColumn = __assign({}, column);
                    rows[currentRow].push(newColumn);
                    parentColumn.colSpan = parentColumn.colSpan || 0;
                    if (newColumn.children && newColumn.children.length > 0) {
                        newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
                        parentColumn.colSpan += newColumn.colSpan;
                    }
                    else {
                        parentColumn.colSpan += 1;
                    }
                    // update rowspan to all same row columns
                    for (var i = 0; i < rows[currentRow].length - 1; i += 1) {
                        setRowSpan(rows[currentRow][i]);
                    }
                    // last column, update rowspan immediately
                    if (index + 1 === columns.length) {
                        setRowSpan(newColumn);
                    }
                    grouped.push(newColumn);
                });
                return grouped;
                /* eslint-enable no-param-reassign */
            };
            return _groupColumns(_this.columns);
        });
    };
    ColumnManager.prototype.normalize = function (elements) {
        var _this = this;
        var columns = [];
        Children.forEach(elements, function (element) {
            if (!isValidElement(element)) {
                return;
            }
            var column = __assign({}, element.props);
            if (element.key) {
                column.key = element.key;
            }
            if (element.type.isTableColumnGroup) {
                column.children = _this.normalize(column.children);
            }
            columns.push(column);
        });
        return columns;
    };
    ColumnManager.prototype.reset = function (columns, elements) {
        this.columns = columns || this.normalize(elements);
        this._cached = {};
    };
    ColumnManager.prototype._cache = function (name, fn) {
        if (name in this._cached) {
            return this._cached[name];
        }
        this._cached[name] = fn();
        return this._cached[name];
    };
    ColumnManager.prototype._leafColumns = function (columns) {
        var _this = this;
        var leafColumns = [];
        columns.forEach(function (column) {
            if (!column.children) {
                leafColumns.push(column);
            }
            else {
                leafColumns.push.apply(leafColumns, __spread(_this._leafColumns(column.children)));
            }
        });
        return leafColumns;
    };
    return ColumnManager;
}());
export default ColumnManager;
/* eslint-enable */
